import { checkDatasetLimit } from './dataset-limits.js';

export const selectedFiles = files => Array.from(files, file => ({ file, path: file.webkitRelativePath || file.name }));

/** Capture drag entries synchronously before the browser protects DataTransfer.
 * Directory readers return batches; keep reading until the empty final batch.
 */
export async function discoverDrop(dataTransfer) {
  const entries = Array.from(dataTransfer?.items || []).filter(item => item.kind === 'file').map(item => item.webkitGetAsEntry?.());
  const files = Array.from(dataTransfer?.files || []);
  if (!entries.some(entry => entry?.isDirectory)) {
    if (!files.length && entries.length) throw new Error('Could not read this drop. Use the folder picker to open a directory dataset.');
    return { entries: selectedFiles(files), directory: false };
  }
  if (entries.some(entry => !entry)) throw new Error('Could not discover every dropped item. Use the folder picker.');
  const found = [];
  let count = 0;
  const walk = async (entry, parent = '') => {
    checkDatasetLimit('discoveredEntries', ++count);
    const path = parent + entry.name;
    if (entry.isFile) {
      const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
      found.push({ path, file });
    } else if (entry.isDirectory) {
      const reader = entry.createReader();
      while (true) {
        const batch = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));
        if (!batch.length) break;
        for (const child of batch) await walk(child, `${path}/`);
      }
    } else throw new Error(`Could not read “${path}”.`);
  };
  try { for (const entry of entries) await walk(entry); }
  catch (error) { throw new Error(`Folder discovery failed: ${error.message || 'a file or folder could not be read'}. No files were loaded.`); }
  return { entries: found, directory: true };
}
